<script>
import { errorFromResponse, notifications } from '~/app/notifications'
import { get } from 'lodash'

export default {
  computed: {
    foxentryEnabled() {
      return this.$store.getters['foxentry/GET_IS_ENABLE']
    },
  },
  methods: {
    async foxentryFormSubmit(formSelector) {
      if (this.foxentryEnabled) {
        const form = document.querySelector(formSelector)
        const { error, warning, valid } = await this.foxentryFormValidation(form)
        if (!valid) {
          if (error) {
            notifications.danger(this.$t('globals.foxentry.notification.error', { input: error }))
          } else if (warning) {
            notifications.warning(this.$t('globals.foxentry.notification.warning', { input: warning }))
          } else {
            notifications.danger(this.$t('globals.foxentry.notification.unknown'))
          }
        }
        return valid
      }
      return true
    },
    async foxentryFormValidation(form) {
      const data = await this.$store.dispatch('foxentry/FORM_VALIDATION', { form })
      return this.foxentryGetFormErrors(data)
    },
    async foxentryFormIsValid(form) {
      return await this.$store.dispatch('foxentry/FORM_IS_VALID', { form })
    },
    async foxentryGetFormErrors(data) {
      const getInputName = data => {
        const { dataset, name } = get(data, '0.input', [])
        const { vvAs } = dataset || {}
        return vvAs || name || false
      }
      try {
        const { valid, inputs, validWithWarnings } = data || {}
        const { invalid, withWarning } = inputs || {}
        return {
          error: getInputName(invalid),
          warning: getInputName(withWarning),
          valid: !!valid || !!validWithWarnings,
        }
      } catch (e) {
        errorFromResponse(e)
      }
    },
  },
}
</script>
